// Mock data for PriEdu

export const topTutors = [
  {
    id: 1,
    name: "Dr. Priya Sharma",
    subjects: ["Mathematics", "Physics"],
    experience: 8,
    rating: 4.9,
    reviews: 156,
    classes: "9-12",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400",
    description: "Expert in advanced mathematics and physics with IIT background"
  },
  {
    id: 2,
    name: "Rahul Verma",
    subjects: ["Chemistry", "Biology"],
    experience: 6,
    rating: 4.8,
    reviews: 142,
    classes: "8-12",
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400",
    description: "Medical entrance exam specialist with proven track record"
  },
  {
    id: 3,
    name: "Anjali Mehta",
    subjects: ["English", "Social Science"],
    experience: 10,
    rating: 4.9,
    reviews: 203,
    classes: "6-10",
    image: "https://images.unsplash.com/photo-1594744803329-e58b31de8bf5?w=400",
    description: "Engaging educator focused on communication and critical thinking"
  },
  {
    id: 4,
    name: "Vikram Singh",
    subjects: ["Computer Science", "Mathematics"],
    experience: 5,
    rating: 4.7,
    reviews: 98,
    classes: "9-12",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400",
    description: "Programming and computational thinking expert"
  },
  {
    id: 5,
    name: "Meera Patel",
    subjects: ["Hindi", "Sanskrit"],
    experience: 12,
    rating: 4.9,
    reviews: 187,
    classes: "1-10",
    image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400",
    description: "Language specialist with cultural insights"
  },
  {
    id: 6,
    name: "Arjun Kumar",
    subjects: ["Economics", "Business Studies"],
    experience: 7,
    rating: 4.8,
    reviews: 134,
    classes: "11-12",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400",
    description: "Commerce stream expert with real-world business experience"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sneha Reddy",
    role: "Parent of Class 10 Student",
    content: "PriEdu helped my daughter improve her math scores from 65% to 92% in just 6 months. The tutors are patient and highly qualified.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200"
  },
  {
    id: 2,
    name: "Aditya Malhotra",
    role: "Class 12 Student",
    content: "The demo class feature is amazing! I could try different tutors before committing. Found the perfect chemistry tutor for JEE prep.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?w=200"
  },
  {
    id: 3,
    name: "Kavita Joshi",
    role: "Parent of Class 8 Student",
    content: "Weekly study plans keep my son organized and motivated. The AI quizzes are a great way to practice. Highly recommend!",
    rating: 5,
    image: "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=200"
  }
];

export const features = [
  {
    id: 1,
    title: "Verified Tutors",
    description: "All tutors undergo rigorous background checks and skill assessments",
    icon: "shield-check"
  },
  {
    id: 2,
    title: "Demo Class Booking",
    description: "Try before you commit with free demo classes from any tutor",
    icon: "video"
  },
  {
    id: 3,
    title: "Weekly Study Plans",
    description: "Personalized study schedules tailored to your learning goals",
    icon: "calendar"
  },
  {
    id: 4,
    title: "AI-Generated Quizzes",
    description: "Smart practice tests that adapt to your learning pace",
    icon: "brain"
  }
];

// Subjects and classes are now loaded dynamically from API
// See tutorService.getBoards(), getClasses(), getSubjects(), getClassSubjects()

export const languages = [
  "English", "Hindi", "Tamil", "Telugu", "Marathi", "Bengali", "Gujarati", "Kannada"
];

export const daysOfWeek = [
  "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"
];

export const timeSlots = [
  "6:00 AM - 8:00 AM",
  "8:00 AM - 10:00 AM",
  "10:00 AM - 12:00 PM",
  "12:00 PM - 2:00 PM",
  "2:00 PM - 4:00 PM",
  "4:00 PM - 6:00 PM",
  "6:00 PM - 8:00 PM",
  "8:00 PM - 10:00 PM"
];

// sampleQuestions removed - now using API data from backend